import { render, staticRenderFns } from "./PassengerPaymentBox.vue?vue&type=template&id=28c69068&"
import script from "./PassengerPaymentBox.vue?vue&type=script&lang=js&"
export * from "./PassengerPaymentBox.vue?vue&type=script&lang=js&"
import style0 from "./PassengerPaymentBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/agent_x64/_work/4/s/TravelportTH/Responsive GO/galileo-online/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAvatar } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
installComponents(component, {VCard,VCardTitle,VContainer,VDivider,VIcon,VList,VListTile,VListTileAvatar,VListTileContent,VListTileTitle})
